export type Feedback = {
  name: string;
  rating: number;
  platform: 'Play Store' | 'Google Play Store' | 'Apple App Store';
  description: string;
};

export const FEEDBACKS: Feedback[] = [
  {
    name: 'Daiane Santos',
    rating: 5.0,
    platform: 'Google Play Store',
    description:
      'Excelente aplicativo, possibilita verificar nome dos conveniados facilitando identificar os descontos em vários estabelecimentos.',
  },
  {
    name: 'Denzell Moreno',
    rating: 5.0,
    platform: 'Google Play Store',
    description:
      'Aplicativo excelente! Consigo fazer os meus agendamentos, além de ter as tele consultas de uma forma prática. Muito bom e parabéns ao grupo Angelus!',
  },
  {
    name: 'Aline Costa',
    rating: 5.0,
    platform: 'Google Play Store',
    description:
      'Acho o App da Angelus muito fácil de encontrar aquilo que se procura, com respostas rápidas para as nossas dúvidas!',
  },
  {
    name: 'Riih Rain',
    rating: 5.0,
    platform: 'Google Play Store',
    description:
      'Aplicativo excelente para fazer o acompanhamento do plano, possui carteirinha digitais e ainda dá pra fazer o pagamento das mensalidades por ele!',
  },
  {
    name: 'Derek Eduardo Gonçalves',
    rating: 5.0,
    platform: 'Google Play Store',
    description:
      'O aplicativo é muito muito bom! Tudo que eu preciso está aqui, consigo facilmente acessar todos os serviços, a visualização da lista de médicos é excelente, eu seriamente recomendo',
  },
  {
    name: 'Jair Milanes',
    rating: 5.0,
    platform: 'Google Play Store',
    description: 'Muito bom, bem prático, fácil de usar. Recomendo.',
  },
  {
    name: 'Ambervision123',
    rating: 5.0,
    platform: 'Apple App Store',
    description:
      'A nova home facilitou muito para encontrar e acessar todos os serviços. Geralmente os que mais utilizo já ficam no topo e consigo resolver as coisas de uma forma mais prática.',
  },
  {
    name: 'José Augusto',
    rating: 5.0,
    platform: 'Google Play Store',
    description: 'Ótimo plano de assistência funeral e assistência médica',
  },
  {
    name: 'Devanir Antonio Mendes',
    rating: 5.0,
    platform: 'Google Play Store',
    description:
      'Excelente e muito prático. Só falta um link para reencaminhar o APP para amigos interessados em aderir ao Angelus.',
  },
  {
    name: 'Nilmar Squisati',
    rating: 5.0,
    platform: 'Google Play Store',
    description:
      'Excelente aplicativo. Tem muitas informações importantes. De Fácil uso.',
  },
  {
    name: 'Maurilio Rodrigues',
    rating: 5.0,
    platform: 'Google Play Store',
    description: 'Bom atendimento e muito facil e rápido',
  },
  {
    name: 'Venceslau Costa Mendes',
    rating: 5.0,
    platform: 'Google Play Store',
    description:
      'Empresa que merece nosso respeito,excelente atendimento,nos passa segurança e tranquilidade nas horas mais difíceis que é lidar com a perda de um ente querido.super recomendo 🙏🙏🙏',
  },
  {
    name: 'Sandra Silva',
    rating: 5.0,
    platform: 'Google Play Store',
    description:
      'Excelente aplicativo, todos os convênios que preciso encontro neste aplicativo.',
  },
  {
    name: 'Phillipe Ramos',
    rating: 5.0,
    platform: 'Apple App Store',
    description:
      'Ficou muito mais fácil achar as informações da minha carteirinha quando preciso. Já consegui uns descontos muito bons também no Clube de Vantagens!',
  },
];
